module.exports = __webpack_public_path__ + "img/0.345df807.jpg";